@if (isMobile$ || !showMoreDesktop) {
  <sd-slider
    [customConfig]="crossSellConfig"
    [brand]="brand"
    #crossSellSlider
    [size]="size"
    (swiperInfo)="onSwiperInfo($event)"
    (slideNext)="onSlideNext($event)"
    (slidePrev)="onSlidePrev($event)"
    [context]="context"
    [itemTemplate]="productCard"
    [items]="products"
  />
}
@if (!isMobile$ && showMoreDesktop) {
  <sd-show-more
    [dynamicContentShowMore]="dynamicContentShowMore"
    [brand]="brand"
    [itemTemplate]="productCard"
    [showLessButton]="false"
    [size]="sizesEnum.s"
    [showSize]="1"
    (more)="onSlideNext($event)"
    (less)="onSlidePrev($event)"
    [items]="products"
  />
}

<ng-template #productCard let-product>
  <article>
    <sd-product-card
      [isSSR]="isSSR"
      [displayStock]="product?.productGenre !== 'Forfait'"
      [brand]="brand ? brand : product?.brand"
      [indexFollow]="product?.indexFollow !== undefined ? product?.indexFollow : true"
      [isLoading]="isLoading"
      (productClicked)="onProductClick($event)"
      (cart)="addToCart(product.code)"
      (favorite)="addToFavorite(product.code)"
      (notify)="stockNotify(product.code)"
      (productSellerModal)="toggleProductSellerModal($event)"
      (reviewsSeeAllClicked)="onReviewsSeeAllClicked(product.code, product.title)"
      [titleLevel]="titleLevel"
      [hasBorder]="hasBorder"
      [isEmbedded]="isEmbedded"
      [isBundle]="product.isBundle"
      [twicPicsAutoSize]="twicPicsAutoSize"
      [productInfo]="product"
      (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
    />
  </article>
</ng-template>
